import {gql} from '@apollo/client'
import {Flow, FlowGenerator, UseFlowQuery} from 'features/procedures/Flow/Flow'
import {useQuery} from 'hooks/graphql'

const HEALTH_INSURANCE_QUALIFICATION_CONFIRMATION_FLOW_QUERY = gql`
  query HealthInsuranceQualificationConfirmationFlowQuery($procedureStatusId: ID!) {
    client {
      id
      procedureStatus(procedureStatusId: $procedureStatusId) {
        id
        employee {
          id
          healthInsurance {
            id
            joined
          }
          currentOffice {
            id
            healthInsuranceType
          }
        }
      }
    }
  }
`

interface FlowQueryData {
  client: {
    id: string
    procedureStatus: {
      id: string
      employee: {
        id: string
        healthInsurance?: {
          id: string
          joined: boolean
        }
        currentOffice: {
          id: string
          healthInsuranceType: 'kyokai' | 'its' | 'other'
        }
      }
    }
  }
}

const useFlowQuery: UseFlowQuery<FlowQueryData> = ({procedureStatusId}) => {
  return useQuery<FlowQueryData>(HEALTH_INSURANCE_QUALIFICATION_CONFIRMATION_FLOW_QUERY, {
    variables: {procedureStatusId},
    fetchPolicy: 'network-only',
  })
}

const makeFlow: FlowGenerator<FlowQueryData> = function* (data) {
  const employee = data.client.procedureStatus.employee
  const healthInsuranceJoined = employee.healthInsurance?.joined
  const healthInsuranceType = employee.currentOffice.healthInsuranceType

  if (healthInsuranceType === 'kyokai' || healthInsuranceType === 'other') {
    if (healthInsuranceJoined) {
      yield 'R9'
    }
  } else if (healthInsuranceType === 'its') {
    if (healthInsuranceJoined) {
      yield 'R10'
    }
  }
}

export const HealthInsuranceQualificationConfirmationFlow = () => (
  <Flow procedureContext="admin" makeFlow={makeFlow} useFlowQuery={useFlowQuery} />
)
